<script>
import {
  required,
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
  name: 'NotifyModal',
  props:[
    "list"
  ],
  data() {
    return {
      form: {},
      submitted: false,
    };
  },
  validations: {
    form: {
      content: { required },
    },
  },
  watch:{
    list(props){
      this.form = {...props}
    }
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) { return; }
        
        if(this.form.id)
          this.update();
        else
          this.create();

      this.$emit('loadItems')
      this.submitted = false;
    },
    create(){
      const { id } = this.$route.params;
      const url =  `/members/${id}/notify/store`
      this.$http.post(url , this.form)
        .then(resp => {
          this.form = {};
         
           notify.success(resp.data.message)
        })
    },
    update(){
      const { id } = this.form
      this.$http.put(`/members/${id}/notify`, this.form)
        .then(resp => {
          this.form = {};
           notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    remove(id){
   
      this.$http.delete(`/members/${id}/notify`)
        .then(resp => {
          if(resp.data.code !==  100)  return notify.error(resp.data.message)
            notify.success(resp.data.message)
            this.close()
            this.$emit('loadItems')
         })
        .catch(error => error)
    },
    close(){
      this.$bvModal.hide('notify_modal')
    }
  },
};
</script>

<template>
  <b-modal id="notify_modal" title="Not Ekle"  no-close-on-backdrop hide-footer>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="content">Not</label>
              <input
                id="content"
                v-model="form.content"
                type="text"
                class="form-control"
                placeholder="Not"
                :class="{
                  'is-invalid': submitted && $v.form.content.$error,
                }"
              />
              <div
                v-if="submitted && !$v.form.content.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
        <div>
          <b-button  variant="danger"  v-if="form.id" @click="remove(form.id)">Sil</b-button>
        </div>
        <div>
          <b-button variant="light" type="button" @click="close()">Vazgeç</b-button>
          <b-button 
            v-if="form.id"
            type="submit" 
            variant="warning" 
            class="ms-1"
            >Güncelle
          </b-button>
          <b-button 
            v-else
            type="submit" 
            variant="success" 
            class="ms-1"
            >Oluştur
          </b-button>
        </div>
        </div>
      </form>
    </b-modal>
</template>